export default __webpack_public_path__ + "static/media/kitchen4-afterE-2048w.6d937e12.webp";